import { TM } from "@litres-libs/tracker-manager";

interface ISafeModeAnaliticsData {
  internalSource: string;
  isActive?: boolean;
}

export const trackerSafeModeClick = ({
  internalSource,
  isActive,
}: ISafeModeAnaliticsData) => {
  TM.sendEvent(["LITRES_TRACKER"], {
    eventType: "safemode_click",
    params: {
      source_internal: internalSource,
      isActive,
    },
  });
};

export const trackerSafeModeShow = ({
  internalSource,
}: ISafeModeAnaliticsData) => {
  TM.sendEvent(["LITRES_TRACKER"], {
    eventType: "safemode_view",
    params: {
      source_internal: internalSource,
    },
  });
};
